export type AnalyticsEvent = {
  name: "cta_click" | "email_click" | "linkedin_click";
  params: Record<string, string>;
};

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}

function cleanText(text: string | null | undefined): string {
  return (text ?? "").replace(/\s+/g, " ").trim().slice(0, 120);
}

function pathFromHref(href: string): string | null {
  try {
    const url = new URL(href, "https://www.evokeadvisory.au");
    return url.pathname;
  } catch {
    return href.startsWith("/") ? href.split(/[?#]/, 1)[0] : null;
  }
}

export function analyticsEventForLink(href: string, label?: string): AnalyticsEvent | null {
  const value = href.trim();
  const eventLabel = cleanText(label);

  if (/^mailto:/i.test(value)) {
    return {
      name: "email_click",
      params: {
        link_url: value,
        link_text: eventLabel,
      },
    };
  }

  try {
    const url = new URL(value, "https://www.evokeadvisory.au");
    const host = url.hostname.replace(/^www\./, "").toLowerCase();
    if (host === "linkedin.com" || host.endsWith(".linkedin.com")) {
      return {
        name: "linkedin_click",
        params: {
          link_url: url.toString(),
          link_text: eventLabel,
        },
      };
    }
  } catch {
    // Non-URL hrefs handled below.
  }

  const path = pathFromHref(value);
  if (path === "/contact") {
    return {
      name: "cta_click",
      params: {
        cta_target: "contact",
        link_url: value,
        link_text: eventLabel,
      },
    };
  }

  if (path === "/briefing" || value === "#briefing" || value.endsWith("#briefing")) {
    return {
      name: "cta_click",
      params: {
        cta_target: "briefing",
        link_url: value,
        link_text: eventLabel,
      },
    };
  }

  return null;
}
